/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {EmailsCheckSettingsActivity} from './EmailsCheckSettingsActivity';
import {EmailsCheckSettingsImport} from './EmailsCheckSettingsImport';
import {EmailsCheckSettingsImportEmails} from './EmailsCheckSettingsImportEmails';

/**
 * The EmailsCheckSettings model module.
 * @module model/EmailsCheckSettings
 * @version 1.0.0
 */
export class EmailsCheckSettings {
  /**
   * Constructs a new <code>EmailsCheckSettings</code>.
   * @alias module:model/EmailsCheckSettings
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsCheckSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsCheckSettings} obj Optional instance to populate.
   * @return {module:model/EmailsCheckSettings} The populated <code>EmailsCheckSettings</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsCheckSettings();
      if (data.hasOwnProperty('import'))
        obj.import = EmailsCheckSettingsImport.constructFromObject(data['import']);
      if (data.hasOwnProperty('importEmails'))
        obj.importEmails = EmailsCheckSettingsImportEmails.constructFromObject(data['importEmails']);
      if (data.hasOwnProperty('activity'))
        obj.activity = EmailsCheckSettingsActivity.constructFromObject(data['activity']);
      if (data.hasOwnProperty('verify'))
        obj.verify = EmailsCheckSettingsActivity.constructFromObject(data['verify']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EmailsCheckSettingsImport} import
 */
EmailsCheckSettings.prototype.import = undefined;

/**
 * @member {module:model/EmailsCheckSettingsImportEmails} importEmails
 */
EmailsCheckSettings.prototype.importEmails = undefined;

/**
 * @member {module:model/EmailsCheckSettingsActivity} activity
 */
EmailsCheckSettings.prototype.activity = undefined;

/**
 * @member {module:model/EmailsCheckSettingsActivity} verify
 */
EmailsCheckSettings.prototype.verify = undefined;

